import React, { useEffect, useState } from 'react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { fetchAboutUs, postAboutUs } from '../../Redux/Reducers/AboutUsReducer';
import { usePermissions } from '../../context/AuthContext'; // Import the permissions hook

export const AboutUs = () => {
    const { can } = usePermissions(); // Instantiate the permissions hook
    const dispatch = useDispatch();
    const { content, status, error } = useSelector((state) => state.AboutUsReducer || {});
    const [data, setData] = useState("");

    useEffect(() => {
        dispatch(fetchAboutUs());
    }, [dispatch]);

    useEffect(() => {
        if (content) {
            setData(content || "");
        }
    }, [content]);

    const handlePostAboutUs = (e) => {
        e.preventDefault();
        dispatch(postAboutUs({ key: "about_us", title: "About Us", content: data }))
            .unwrap()
            .then(() => {
                toast.success("About Us content saved successfully!");
            })
            .catch((err) => {
                toast.error(err.message || "Failed to save About Us content.");
            });
    };

    const handleTextChange = (event, editor) => {
        const text = editor?.getData();
        setData(text);
    };

    return (
        <>
            <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                <h3 className="mb-0 fw-bold">About Us</h3>
            </div>
            <hr />
            <div className="card-body">
                <form>
                    <div className="row g-3 align-items-center">
                        <div className="col-md-12">
                            <CKEditor
                                editor={ClassicEditor}
                                data={data}
                                config={{
                                    toolbar: [
                                        "heading",
                                        "|",
                                        "bold",
                                        "italic",
                                        "link",
                                        "bulletedList",
                                        "numberedList",
                                        "|",
                                        "blockQuote",
                                        "insertTable",
                                        "|",
                                        "undo",
                                        "redo"
                                    ],
                                    placeholder: "Enter About Us content here..."
                                }}
                                onChange={handleTextChange}
                                // Disable the editor if the user does not have edit permission
                                disabled={!can('about_us:edit')}
                            />
                        </div>
                    </div>
                    <br />
                    <div className="d-flex justify-content-end">
                        {/* Show the save button only if the user has edit permission */}
                        {can('about_us:edit') && (
                            <button
                                type="submit"
                                onClick={handlePostAboutUs}
                                className="btn btn-primary btn-set-task w-sm-100 text-uppercase px-5"
                                disabled={status === 'loading'}
                            >
                                {status === 'loading' ? 'Saving...' : 'Save'}
                            </button>
                        )}
                    </div>
                </form>
            </div>
        </>
    );
};

export default AboutUs;